import { useMemo } from 'react';

import { useCurrentWorkspace } from 'src/store';

export const useBrandVoices = () => {
  const currentWorkspace = useCurrentWorkspace();

  return useMemo(
    () => ({
      brandVoices: currentWorkspace?.associatedBrandVoices || [],
      defaultBrandVoice: currentWorkspace?.defaultBrandVoice,
    }),
    [currentWorkspace]
  );
};
